<template>
  <card-container
    :id="pageId"
    :is-loading="isLoading"
    :disabled="isLoading"
    loading-message="Sending Driver Arriving Call..."
    @submit="sendDriverArrivingCall"
    @reset="resetForm"
  >
    <template #title>
      Send Driver Arriving Call
    </template>

    <template #content>
      <div class="row align-items-center">
        <label class="col-sm-3 control-label">Caller ID*</label>
        <div class="col-sm-7">
          <sanitized-input
            :id="`callerId-${pageId}`"
            v-model="requestBody.callerId"
            placeholder="Please input caller id"
            required
          />
        </div>
      </div>

      <div class="row">
        <label class="col-sm-3 control-label pt-10"> Phone Number </label>
        <phone-number-input
          id="customer-phone"
          v-model="requestBody.phoneNumber"
          class="col-sm-7"
          :page-id="pageId"
          :required="false"
        >
          <template #help-block>
            If no phone number is inputed, the driver arriving call will be sent to the preferred contact number of the ride. If you would
            like to have the driver arriving call sent to a different phone number, please enter it here
          </template>
        </phone-number-input>
      </div>
    </template>

    <template #submit-button>
      Send Driver Arriving Call
    </template>
  </card-container>
</template>

<script lang="ts">
import { ref, Ref, watch } from 'vue';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useSwalDialog } from '@/use/swalDialog';
import { sendPost } from '@/Utils/api';

const pageId = 'driver-arriving-call';

export default {
  name: 'DriverArrivingCall',

  setup: () => {
    const { customerInfo } = useCustomer();
    const { showSuccessPopupDialog, showErrorPopupDialog } = useSwalDialog();

    const requestBody: Ref<any> = ref({
      callerId: '',
      phoneNumber: '',
    });

    const isLoading = ref(false);

    const sendDriverArrivingCall = async () => {
      // if phone number is invalid, init with empty string
      requestBody.value.phoneNumber = util.getValidPhoneNumber(requestBody.value.phoneNumber);

      isLoading.value = true;
      try {
        // POST /sendDriverArrivingCall
        /*
          body => {
            callerId: ***,
            phoneNumber?: ***,
          }
        */
        await sendPost('sendDriverArrivingCall', requestBody.value);
        showSuccessPopupDialog({
          text: 'The driver arriving call has been sent successfully!',
        });
      } catch (error) {
        const errorText = util.getErrorResponse(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      }
      isLoading.value = false;
    };

    const resetForm = () => {
      requestBody.value = {
        callerId: '',
        phoneNumber: '',
      };
    };

    watch(
      customerInfo,
      (value: any) => {
        resetForm();
        requestBody.value.callerId = value?.id;
      },
      {
        immediate: true,
      },
    );

    return {
      pageId,
      requestBody,
      isLoading,

      sendDriverArrivingCall,
      resetForm,
    };
  },
};
</script>
